<template>
    <b-modal
            :visible="show"
            @hidden="hideEvents"
            title="Remove Tag"
            :id="modalId"
    >
        <vue-element-loading :active="loading" :is-full-screen="false"/>
        <b-form>
            <b-form-group
                    label="Tags"
            >
            <tag-select
                ref="tagSelect"
                placeholder="Select one or more tags to remove"
                v-model="value"
                :options="options"
                :taggable=false
                :multiple=false
            >
            </tag-select>
            </b-form-group>
        </b-form>
        <template slot="modal-footer">
            <b-button
                    variant="outline-secondary"
                    @click="hideModal">
                Cancel
                <font-awesome-icon
                        :icon="['far', 'times']">
                </font-awesome-icon>
            </b-button>
            <b-button
                    class="btn-arrow"
                    variant="primary"
                    @click="tagActions"
                    :disabled="tagDisabled"
            >
                Remove
                <font-awesome-icon
                        :icon="['far', 'arrow-right']">
                </font-awesome-icon>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TagSelect from '@/components/Form/TagSelect';
import ModalMixin from '@/components/Modal/ModalMixin';
import Action from '@/services/Action/Action';
import Tags from '@/services/Tags/Tags';

export default {
  name: 'Remove-Tags-Modal',
  components: {
    TagSelect,
  },
  mixins: [ModalMixin],
  data() {
    return {
      modalId: 'removeTagsModal',
      loading: false,
      value: [],
      options: [],
    };
  },
  computed: {
    tagDisabled() {
      return (this.nodeIds.length === 0 || this.value.length === 0) || this.loading;
    },
    ...mapGetters({ showSearch: 'propertyShowSearch' }),
  },
  async mounted() {
    this.getTags();
  },
  methods: {
    async getTags() {
      this.loading = true;

      try {
        const { data } = await Action.getTagsForActions(this.nodeIds);
        this.options = Tags.formatDataToMultiSelectObj(data.data);
      } catch (e) {
        this.$notify({
          title: 'Error',
          text: 'Something went wrong. Please try again later.',
          type: 'error',
        });
      } finally {
        this.loading = false;
      }
    },
    async tagActions() {
      if (this.nodeIds.length === 0 || !this.validate()) {
        return;
      }

      this.loading = true;

      try {
        const response = await this.$store.dispatch(
          'removeTags',
          {
            clientActionIds: this.nodeIds,
            tags: [this.value.name],
          },
        );

        this.$notify({
          title: 'Success',
          text: `All ${response.data.meta.total} actions have been untagged.`,
          type: 'success',
        });

        this.$store.dispatch('refreshActions');
        this.$store.dispatch('refreshTags');
      } catch (e) {
        this.$notify({
          title: 'Error',
          text: 'Something went wrong. Please try again later.',
          type: 'error',
        });
      } finally {
        this.hideModal();
      }
    },

    validate() {
      if (this.value.length === 0) {
        this.$notify({
          title: 'Error',
          text: 'Please select a tag',
          type: 'error',
        });
        return false;
      }
      return true;
    },

    hideModalEvents() {
      this.value = [];
    },
  },
};
</script>

<style lang="scss">
.modal {
  .btn.btn-arrow {
    min-width: 140px;
  }

  .btn-outline-secondary + .btn-arrow {
    margin: auto;
    margin-right: 0;
  }
}
</style>
